<!-- Global Hero Section -->
<header class="hero-section-global">
  <div class="hero-background-global"
    style="background-image: url('https://images.ctfassets.net/f6ou4743hwzs/2xaL3IYyS5iU8bcXoWAOdX/9d1784950839614bbbcaa593c23ee090/whyblm.jpg'); background-position: center 40%;">
  </div>
  <div class="hero-overlay-global"></div>
  <div class="hero-content-global">
    <h1 class="hero-title-global">Plan Your Visit</h1>
    <p class="lead"
      style="color: rgba(255,255,255,0.9); border: none; background: none; text-shadow: 0 2px 4px rgba(0,0,0,0.5);">
      Schedule a private group tour or school visit at the historic 1912 schoolhouse.
    </p>
  </div>
</header>

<main class="container appointment-container">
  <div class="appointment-grid">
    <!-- Visit Information Card -->
    <div class="visit-info-card">
      <span class="badge">Visitor Information</span>
      <h2>Planning a Private Tour</h2>
      <p>
        While the museum is regularly open to the public on <strong>Saturdays from Noon to 4:00 PM</strong>, we warmly welcome private group tours, school field trips, and historical society groups on Thursdays, Fridays, and Saturdays by appointment.
      </p>

      <div class="highlights-list">
        <div class="highlight-item">
          <mat-icon class="highlight-icon">schedule</mat-icon>
          <div>
            <h4>General Admission Hours</h4>
            <p>Saturdays: Noon – 4:00 PM (No appointment needed)</p>
          </div>
        </div>

        <div class="highlight-item">
          <mat-icon class="highlight-icon">groups</mat-icon>
          <div>
            <h4>Group & School Tours</h4>
            <p>Available Thursday – Saturday by appointment. Customized docent-led tours available.</p>
          </div>
        </div>

        <div class="highlight-item">
          <mat-icon class="highlight-icon">payments</mat-icon>
          <div>
            <h4>Admission</h4>
            <p>Adults: $3.00 &bull; Seniors & Students: $2.00 &bull; Children under 6: Free</p>
          </div>
        </div>

        <div class="highlight-item">
          <mat-icon class="highlight-icon">phone</mat-icon>
          <div>
            <h4>Direct Contact</h4>
            <p>Prefer to call or text? <a href="tel:(985) 664-0256" class="phone-link">(985) 664-0256</a></p>
          </div>
        </div>
      </div>
    </div>

    <!-- Booking Form Card -->
    <div class="booking-form-card">
      <div [hidden]="success">
        <h3>Book an Appointment</h3>
        <p class="form-intro">Select your preferred date and time, and we’ll confirm your tour.</p>

        <form [formGroup]="myForm" (ngSubmit)="onSubmit()" class="styled-appointment-form">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Your Name</mat-label>
            <input matInput formControlName="name" autocomplete="name" placeholder="Full name" required>
            <mat-icon matPrefix>person</mat-icon>
            <mat-error *ngIf="name.errors && (name.dirty || name.touched)">
              Name is required
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Email Address</mat-label>
            <input matInput formControlName="email" autocomplete="email" placeholder="email@example.com" required>
            <mat-icon matPrefix>email</mat-icon>
            <mat-error *ngIf="email.errors && (email.dirty || email.touched)">
              Valid email is required
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Phone Number</mat-label>
            <input matInput formControlName="phone" autocomplete="tel" placeholder="(985) 000-0000">
            <mat-icon matPrefix>phone</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Preferred Tour Date</mat-label>
            <input matInput [min]="minDate" [matDatepickerFilter]="myFilter" [matDatepicker]="picker" formControlName="date" autocomplete="off" required placeholder="Choose a Thu, Fri, or Sat">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker touchUi #picker></mat-datepicker>
            <mat-error *ngIf="date.errors && (date.dirty || date.touched)">
              Please select a tour date
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Preferred Time Slot</mat-label>
            <select matNativeControl formControlName="time" required>
              <option value="" disabled selected>Select a time</option>
              <option value="10AM">10:00 AM</option>
              <option value="11AM">11:00 AM</option>
              <option value="12PM">12:00 PM (Noon)</option>
              <option value="1PM">1:00 PM</option>
              <option value="2PM">2:00 PM</option>
              <option value="3PM">3:00 PM</option>
            </select>
            <mat-error *ngIf="time.errors && (time.dirty || time.touched)">
              Please choose a time slot
            </mat-error>
          </mat-form-field>

          <button mat-flat-button color="primary" class="submit-btn" [disabled]="myForm.invalid || loading" type="submit">
            <mat-icon>event_available</mat-icon>
            {{ loading ? 'Booking...' : 'Request Tour Appointment' }}
          </button>
        </form>
      </div>

      <div class="success-message" *ngIf="success">
        <mat-icon class="success-icon">check_circle</mat-icon>
        <h3>Appointment Requested!</h3>
        <p>Your request for <strong>{{ submittedData.dateFormatted }} at {{ submittedData.time }}</strong> has been recorded.</p>
        
        <div class="email-action-box">
          <p class="email-action-desc">
            Want immediate confirmation? Click below to send your prefilled tour request directly to our tour coordinators:
          </p>
          <a [href]="mailtoLink" class="email-confirm-btn">
            <mat-icon>email</mat-icon>
            <span>Confirm Tour via Email</span>
          </a>
        </div>

        <div style="margin-top: 1.5rem;">
          <button mat-stroked-button color="primary" routerLink="/">Return Home</button>
        </div>
      </div>
    </div>
  </div>
</main>